import PVACase from "../Components/References/PVACase";
import Footer from "../Components/Footer";

const PVA = () => {
    return (
      <div>
        <PVACase />
        <Footer />
      </div>
    );
  };
  
  export default PVA;